import moment from 'moment';
import { getLocale } from 'umi';
import { Lang } from '../types/lang';
export const splitNumber = (num: number) => {
  const numberStr = String(num);
  let reg = /(.{3})/g;
  if (numberStr.length === 6 || numberStr.length === 9) {
    return numberStr.replace(reg, '$1 ');
  }
  if (numberStr.length === 8 || numberStr.length === 10) {
    reg = /(.{4})/g;
    return numberStr.replace(reg, '$1 ');
  }
  return numberStr;
};

// 将日期时间字符串(默认没有时区，但实际是东八区)，转为时间戳
export function stringTimeToTimeNumber(timeString: string | undefined) {
  if (timeString?.match?.('T') && !timeString?.match?.(/[+-][0-9]{2}:[0-9]{2}$/)) {
    return new Date(`${timeString}+08:00`).getTime();
  }
  return timeString;
}

export const durationTime = (now: number, old: number) => {
  const du = moment.duration(now - old, 'ms');
  let time = '';
  const hours = Math.floor(du.as('hours'));
  const mins = du.get('minutes');
  const second = du.get('seconds');
  const hh = hours < 10 ? `0${hours}` : hours;
  const mm = mins < 10 ? `0${mins}` : mins;
  const ss = second < 10 ? `0${second}` : second;
  if (hours > 0) {
    time = `${hh}:${mm}:${ss}`;
  } else {
    time = `${mm}:${ss}`;
  }
  return time;
};

export function getUserMedia(type: any) {
  return new Promise((resolve, reject) => {
    (navigator as any).getUserMedia(
      type,
      async (stream: any) => {
        resolve(stream);
      },
      (error: any) => {
        reject(error);
      }
    );
  });
}

export const clearSessionStorage = () => {
  window.sessionStorage.removeItem('isOpenVideo');
  window.sessionStorage.removeItem('isOpenAudio');
  window.sessionStorage.removeItem('cid');
  window.sessionStorage.removeItem('sessionId');
  window.sessionStorage.removeItem('uid');
  window.sessionStorage.removeItem('yxuid');
  window.sessionStorage.removeItem('avatarUrl');
  window.sessionStorage.removeItem('name');
  window.sessionStorage.removeItem('micId');
  window.sessionStorage.removeItem('cameraId');
};

export const profile =
  { 'test-meet.popo.netease.com': 'test', 'meet.popo.netease.com': 'prod' }[window.location.host] ??
  'office';

export const getAvatarStr = (src: string): string => {
  const pattern = new RegExp(
    "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？↵·]",
    'g'
  );
  const name = src.replaceAll(pattern, '');
  let str = '';
  if (name.length === 0) {
    str = src.slice(0, 1);
  } else if (/^[0-9\s]*$/.test(name)) {
    // 数字和空格组合
    str = name.replaceAll(/\s/g, '').slice(0, 2);
  } else if (/^[a-zA-Z\s]*$/.test(name)) {
    // 字母和空格
    const arr = name.split(' ');
    if (arr.length > 1) {
      str = arr[0].slice(0, 1) + arr[arr.length - 1].slice(0, 1);
    } else {
      str = arr[0].slice(0, 1);
    }
    // } else if (/[a-zA-Z]/.test(name)) {
    //   // 包含英文字符
    //   for (let i = 0; i < name.length; i++) {
    //     if (/[a-z]/i.test(name[i])) {
    //       str = name[i];
    //       break;
    //     }
    //   }
  } else if (/^[\u4E00-\u9FA5\u0800-\u4e00\s]+$/.test(name)) {
    // 仅有中文日文和空格字符
    str = name.replaceAll(/\s/g, '').slice(-2);
  } else {
    str = name.slice(0, 1);
  }
  return str.toUpperCase();
};
//当前是否是横屏：
export function isLandscape() {
  // 由于 ipad 内置 webview 不支持 orientation ,改用宽高比较判断是否为横屏
  console.log(window.innerHeight, window.innerWidth);
  return window.innerWidth > window.innerHeight;
}

// 是否在第一页，一页九个
export const nowSpeakInOnePage = (members: any[], yxUid: string | undefined) => {
  if (!yxUid || !members.length) {
    return;
  }
  return members.slice(0, 9).filter((member) => member.yxUidStr === yxUid).length > 0;
};

// devtool 初始化
export default function devInit(password: string, callBack: () => any) {
  const mm = password || '左右左右空空';
  function initOpen() {
    callBack && callBack();
  }
  if (password === '') {
    initOpen();
  }
  const delay = 1500;
  let timer: any = 0;
  let clickKey = '';
  document.addEventListener(
    'click',
    function (event) {
      const touch = event;
      timer && clearTimeout(timer);
      if (!clickKey) {
        clickKey = '';
      }
      console.log(clickKey, 'clickKey');
      if (touch) {
        const x = touch.clientX;
        const y = touch.clientY;
        const winW = window.innerWidth;
        const winH = window.innerHeight;
        let key = '空';
        if (x >= winW / 3 && x <= (winW / 3) * 2 && y <= winH / 2) {
          key = '上';
        } else if (x >= winW / 3 && x <= (winW / 3) * 2 && y >= winH / 2) {
          key = '下';
        } else if (x <= winW / 2 && y >= winH / 3 && y <= (winH / 3) * 2) {
          key = '左';
        } else if (x >= winW / 2 && y >= winH / 3 && y <= (winH / 3) * 2) {
          key = '右';
        }
        if (key === mm[clickKey.length]) {
          clickKey += key;
        } else {
          clickKey = '';
        }
      }
      if (clickKey === mm) {
        sessionStorage.setItem('devOpen', 'true');
        initOpen();
      }
      timer = setTimeout(function () {
        clickKey = '';
      }, delay);
    },
    true
  );

  if (sessionStorage.getItem('devOpen') === 'true') {
    initOpen();
  }
}

/**
 * 加载外部的js文件
 * @param url 要加载的js的url地址
 *
 */
const scriptCache: Record<string, Promise<any>> = {};
export function loadScript(url: string, cache = true): Promise<any> {
  if (scriptCache[url] && cache) return scriptCache[url];
  const scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('charset', 'utf-8');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    document.getElementsByTagName('head')[0].appendChild(script);

    const timeout = setTimeout(() => {
      reject('timeout'); // rejected
    }, 5000);

    script.onload = () => {
      // 加载完成
      clearTimeout(timeout);
      resolve(); // fulfilled
    };
    script.onerror = (err) => {
      // 加载失败
      reject(err); // rejected
    };
  });
  scriptCache[url] = scriptPromise;
  scriptPromise.catch((err) => {
    console.warn(err);
    delete scriptCache[url];
  });
  return scriptPromise;
}

// 获取当前语言
export const getwebLocales = () => {
  let lang;
  const sLocale = getLocale().toLowerCase();
  if (sLocale.includes('en')) {
    lang = Lang.en;
  } else if (sLocale.includes('ja')) {
    lang = Lang.ja;
  } else {
    lang = Lang.zh;
  }
  return lang;
};

// 获取当前url的参数
export function getQueryString(name: string) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.replace('?', '&').substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

// 时间转换
export const getMeetingTime = (time: string) => {
  const chineseDay = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  const enDy = ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];
  const jaDy = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];

  const newTime = stringTimeToTimeNumber(time);
  const day = moment(newTime).day();
  const mm = moment(newTime).hour() > 12 ? '下午' : '上午';
  const language = getLocale();
  if (language.includes('en')) {
    const mm = moment(newTime).hour() > 12 ? 'PM' : 'AM';
    return (
      moment(newTime).format('M/D') + ' ' + enDy[day] + ' ' + `${moment(time).format('h:mm')}${mm}`
    );
  }

  if (language.includes('ja')) {
    const mm = moment(newTime).hour() > 12 ? 'PM' : 'AM';
    return (
      moment(newTime).format('M月D日') +
      ' ' +
      jaDy[day] +
      ' ' +
      `${moment(time).format('h:mm')}${mm}`
    );
  }
  return (
    moment(newTime).format('M月D日') +
    ' ' +
    chineseDay[day] +
    ' ' +
    mm +
    ' ' +
    moment(time).format('h:mm')
  );
};

getMeetingTime('2024-04-29T15:30:00');
//  下载app
export function downloadApp() {
  window.open('https://popo.netease.com/');
}

//生成打开popo弹窗
export function schemaEncode({ meetingId, type = 'join' }: { meetingId: string; type?: string }) {
  const dataMapStr = JSON.stringify({
    business: 'meeting',
    business_param: {
      oper_id: meetingId,
      oper_type: type,
    },
  });
  return `ntes-popo-launch://${dataMapStr}`;
}

export function initSvgIcons() {
  // loadScript('//at.alicdn.com/t/c/font_2328332_hha6og8j8xr.js', true);
  // //https://www.iconfont.cn/manage/index?spm=a313x.manage_index.i1.db775f1f3.43ab3a81cMOZ4M&manage_type=myprojects&projectId=4299569
  // loadScript('//at.alicdn.com/t/c/font_4299569_rwxna8yhp9.js', true);
  // https://www.iconfont.cn/manage/index?spm=a313x.manage_index.i1.db775f1f3.43ab3a81cMOZ4M&manage_type=myprojects&projectId=4461905
  loadScript('//at.alicdn.com/t/c/font_4461905_de0de3o2hsp.js', true);
}

export const getWhiteBoardPlatform = () => {
  let platform = 'web';
  if (isiOSApp) {
    platform = 'ios';
  } else if (isAndroidApp) {
    platform = 'android';
  } else if (isMobile) {
    if (/iPhone/.test(window.navigator.userAgent)) {
      platform = 'ios';
    } else if (/Android/.test(window.navigator.userAgent)) {
      platform = 'android';
    }
  }

  return platform;
};

export const getBase64Image = (
  width: number,
  height: number,
  base64String: string
): Promise<string> => {
  var img = new Image();
  img.src = base64String;
  // 等待图像加载完成
  return new Promise((resolve, reject) => {
    img.onload = function () {
      // 创建一个Canvas元素
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      // 设置新的宽度和高度
      var newWidth = width;
      var newHeight = height;
      canvas.width = newWidth;
      canvas.height = newHeight;

      // 在Canvas上绘制图像并指定新的宽度和高度
      ctx?.drawImage(img, 0, 0, newWidth, newHeight);

      // 将Canvas转换为新的base64格式字符串
      resolve(canvas.toDataURL('image/png') || base64String);
    };
    loadScript('//at.alicdn.com/t/c/font_4461905_yjrbafjy2ek.js', true);
  });
};

export const initScout = () => {
  window.ScoutContext.onLoad(() => {
    if (window.Scout) {
      window.Scout.init({
        appId: '15d46f9c',
        instrumentEnable: {
          fetch: true, // 启动fetch劫持
          xhr: true, // 启动xhr劫持
        },
        effectHosts: ['test-meet.popo.netease.com', 'meet.popo.netease.com'],
        beforeSend: (requestBody: any) => {
          if (requestBody.type === 'error' && requestBody.errors) {
            requestBody.errors.forEach((errorEvent: any) => {
              if (window.location.href.includes('test-meet.popo.netease.com')) {
                errorEvent.customTags = [{ key: 'env', value: 'test03' }];
              } else if (window.location.href.includes('meet.popo.netease.com')) {
                errorEvent.customTags = [{ key: 'env', value: 'prod' }];
              }
            });
          }
          return requestBody;
        },
        // 屏蔽云信和埋点上报
        beforeSendRequestLog(requestLog: { url: string | string[] }) {
          if (
            requestLog?.url?.includes('sigma-webmeeting-popo.proxima.nie.easebar.com') ||
            requestLog?.url?.includes('statistic.live.126.net')
          ) {
            return undefined;
          }
          // 可以在这里特殊处理某些敏感的请求, 如果返回falsy的值，则不会上报
          return requestLog;
        },
        requestLogLevel: 2, // 表示记录 url, response status
      });
    }
  });
};
